import { Injectable, inject } from '@angular/core';
import {Observable, Subject, tap} from "rxjs";
import {ApplicationType} from "../model/Application";
import {ActivationEnd, EventType, Router} from "@angular/router";
import {filter, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ActiveFormService {

  constructor() {
    const router = inject(Router);

    router.events.pipe(
      filter(event => event.type === EventType.ActivationEnd),
      map(event => (event as ActivationEnd).snapshot),
      filter(snapshot => snapshot.component != null),
      tap(() => this.setActiveForm(null)),
      map(snapshot => (snapshot.url?.[0]?.path?.toUpperCase() ?? null) as ApplicationType | null),
      tap(type => this.setActiveForm(type))
    ).subscribe()
  }

  private readonly activeFormSubject: Subject<ApplicationType | null> = new Subject()

  private setActiveForm(applicationType: ApplicationType | null) {
    this.activeFormSubject.next(applicationType)
  }

  getActiveForm(): Observable<ApplicationType | null> {
    return this.activeFormSubject.asObservable()
  }
}
